import { DEFAULT_CURRENCY, DEFAULT_LOCALE } from '../constants';

/**
 * Formats a number as currency using Intl.NumberFormat
 * @param amount - The amount to format
 * @param currency - The currency code (ISO 4217), defaults to DEFAULT_CURRENCY
 * @param locale - The locale string, defaults to DEFAULT_LOCALE
 * @returns Formatted currency string
 */
export const formatCurrency = (
    amount: number,
    currency: string = DEFAULT_CURRENCY,
    locale: string = DEFAULT_LOCALE,
): string =>
    new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
